// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAu6NootofK5btGSYDuHF8AJjKJAqto6OE",
  authDomain: "kbc-portfolio.firebaseapp.com",
  projectId: "kbc-portfolio",
  storageBucket: "kbc-portfolio.firebasestorage.app",
  messagingSenderId: "4856581016",
  appId: "1:4856581016:web:0dd6a1a353fd5eeb2539ed",
  measurementId: "G-73S8W7XMWV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

const db = getFirestore(app)

const functions = getFunctions(app);
const email = httpsCallable(functions, 'triggerEmail');
export { email, db };